// extracted by mini-css-extract-plugin
export default {"wrapper":"categories_wrapper__sscly","w":"categories_w__zuO3f","rounded":"categories_rounded__n8nTn"};